export default __webpack_public_path__ + "static/media/ReleaseNotes_Content_BrokerNotes1.0b54b1d4.png";